import { API, Auth } from "aws-amplify";
import { listUnreadConversations } from "@/api/buyerMessages";

// Unread buyer-message conversations. The sidebar badge counts them, the Order
// Queue badges key off them, and the Messages page re-queries when `refreshedAt`
// ticks (the 120 s layout poll), so read state changed in another session shows
// up everywhere without its own timer.
const state = { unread: [], loaded: false, refreshedAt: 0 };

const mutations = {
  SET_UNREAD(state, rows) {
    state.unread = rows;
    state.loaded = true;
    state.refreshedAt = Date.now();
  },
};

const actions = {
  // Not `refresh`, so it cannot collide with a root-level action.
  async refreshMessagesUnread({ commit }) {
    const user = await Auth.currentAuthenticatedUser();
    commit("SET_UNREAD", await listUnreadConversations(API, user.username));
  },
};

const getters = {
  messagesBadge: (state) => (state.loaded ? state.unread.length : 0),
  messagesLoaded: (state) => state.loaded,
  unreadConversations: (state) => state.unread,
  messagesRefreshedAt: (state) => state.refreshedAt,
};

export default { namespaced: false, state, mutations, actions, getters };
